import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import reviews from "./reviews.json"; // Importujemy plik z opiniami

const ReviewsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(5); // Domyślna liczba widocznych kafelków
  const carouselRef = useRef(null);
  const touchStartX = useRef(null); // Początkowa pozycja dotyku (X)
  const touchEndX = useRef(null); // Końcowa pozycja dotyku (X)
  const isDragging = useRef(false); // Czy użytkownik przeciąga karuzelę
  const initialTranslateX = useRef(0); // Początkowa wartość transformacji

  // Funkcja do aktualizacji liczby widocznych kafelków na podstawie szerokości ekranu
  const updateVisibleCards = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 1800) {
      setVisibleCards(6); // Duże ekrany
    } else if (screenWidth >= 1500) {
      setVisibleCards(5); // Średnie ekrany
    } else if (screenWidth >= 1000) {
      setVisibleCards(4); // Średnie ekrany
    } else if (screenWidth >= 700) {
      setVisibleCards(3); // Średnie ekrany
    } else if (screenWidth >= 500) {
      setVisibleCards(2); // Średnie ekrany
    } else if (screenWidth >= 300) {
      setVisibleCards(1); // Średnie ekrany
    } else {
      setVisibleCards(1); // Małe ekrany (telefony)
    }
  };

  // Efekt do śledzenia zmian szerokości ekranu
  useEffect(() => {
    updateVisibleCards(); // Ustaw początkową wartość
    window.addEventListener("resize", updateVisibleCards); // Aktualizuj przy zmianie rozmiaru

    return () => {
      window.removeEventListener("resize", updateVisibleCards); // Sprzątanie
    };
  }, []);

  // Obsługa dotyku
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX; // Zapisujemy początkową pozycję X
    initialTranslateX.current = -currentIndex * (100 / visibleCards); // Zapisujemy początkową transformację
    isDragging.current = true; // Użytkownik zaczyna przeciągać
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;

    touchEndX.current = e.touches[0].clientX; // Zapisujemy aktualną pozycję X
    const deltaX = touchEndX.current - touchStartX.current; // Różnica w pozycji X
    const newTranslateX = initialTranslateX.current + (deltaX / window.innerWidth) * 100; // Nowa transformacja

    // Aktualizujemy transformację karuzeli
    carouselRef.current.style.transform = `translateX(${newTranslateX}%)`;
  };

  const handleTouchEnd = () => {
    if (!isDragging.current) return;

    const deltaX = touchEndX.current - touchStartX.current; // Różnica w pozycji X
    const cardWidth = 100 / visibleCards; // Szerokość jednego kafelka w procentach

    // Obliczamy nowy indeks na podstawie przesunięcia
    let newIndex = currentIndex;
    if (Math.abs(deltaX) > 50) { // Minimalny próg przesunięcia
      newIndex = deltaX > 0 ? currentIndex - 1 : currentIndex + 1;
    }

    // Ograniczamy indeks do zakresu
    newIndex = Math.max(0, Math.min(newIndex, reviews.length - visibleCards));

    // Aktualizujemy indeks i transformację
    setCurrentIndex(newIndex);
    carouselRef.current.style.transform = `translateX(-${newIndex * cardWidth}%)`;

    // Resetujemy wartości
    touchStartX.current = null;
    touchEndX.current = null;
    isDragging.current = false;
  };

  const handleNext = () => {
    if (currentIndex < reviews.length - visibleCards) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div
      className="reviews-carousel reveal2"
      style={{ "--visible-cards": visibleCards }} // Przekazujemy wartość do CSS
    >
      <button
        className="nav-button prev"
        onClick={handlePrev}
        disabled={currentIndex === 0}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <div
        className="carousel-container"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="carousel-track"
          ref={carouselRef}
          style={{
            transform: `translateX(-${currentIndex * (100 / visibleCards)}%)`,
          }}
        >
          {reviews.map((review, index) => (
            <div key={index} className="review-card">
              <div className="author">{review.author}</div>
              <div className="rating">
                {[...Array(5)].map((_, i) => (
                  <span
                    key={i}
                    className={`star ${i < review.rating ? "gold" : "gray"}`}
                  >
                    ★
                  </span>
                ))}
              </div>
              <div className="snippet">{review.snippet}</div>
            </div>
          ))}
        </div>
      </div>
      <button
        className="nav-button next"
        onClick={handleNext}
        disabled={currentIndex >= reviews.length - visibleCards}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};

export default ReviewsCarousel;